<template>
    <div>
        <Cv :strings="strings" :cv="cv"/>
    </div>
</template>

<script>
    import Cv from "./CV";
    import translations from "../translations";

    console.log('Translations ', translations)
    export default {
        components: {Cv},
        data() {
            return {
                language: 'es'
            }
        },
        computed: {
            translations() {
                return translations[this.language]
            },
            cv() {
                return this.translations.cv
            },
            strings() {
                return this.translations.strings
            }
        }
    }
</script>
<style>
    .btn {
        background-color: white;
        border: 2px solid lightgray;
        font-size: 20px;
        line-height: 20px;
    }

    .btn:first-child {
        border-radius: 5px 0px 0px 5px;
    }

    .btn:last-child {
        border-radius: 0px 5px 5px 0px;
    }


    .btn:focus {
        border: 2px solid #305fec;
    }

    .btn-active {
        border: 2px solid #305fec;
    }
</style>
